import { render, staticRenderFns } from "./VuetifyAdminLayout.vue?vue&type=template&id=b197132e&"
import script from "./VuetifyAdminLayout.vue?vue&type=script&lang=js&"
export * from "./VuetifyAdminLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports